import gql from 'graphql-tag';

const INVITE_USER_TO_WORKSPACE = gql`
  mutation SendWorkspaceInvitation(
    $workspaceId: ID!
    $invitation: InvitationInput!
  ) {
    sendWorkspaceInvitation(
      workspaceId: $workspaceId
      invitation: $invitation
    ) {
      id
      email
      workspaceId
      customerId
      token
      status
    }
  }
`;

const INVITE_USER_TO_CUSTOMER = gql`
  mutation SendCustomerInvitation(
    $customerId: ID!
    $invitation: InvitationInput!
  ) {
    sendCustomerInvitation(customerId: $customerId, invitation: $invitation) {
      id
      email
      workspaceId
      customerId
      token
      status
    }
  }
`;

const INVITE_TREINCO_APP_TO_WORKSPACE = gql`
  mutation SendTreincoAppInvitation(
    $workspaceId: ID!
    $invitation: AppInvitationInput!
  ) {
    sendTreincoAppInvitation(
      workspaceId: $workspaceId
      invitation: $invitation
    ) {
      id
      email
      workspaceId
      customerId
      token
      status
    }
  }
`;

const ACCEPT_WORKSPACE_INVITATION = gql`
  mutation AcceptWorkspaceInvitation($token: String!) {
    acceptInvitation(token: $token) {
      userRoles {
        id
        account {
          id
        }
        workspace {
          id
          name
          mode
        }
        role {
          name
        }
      }
    }
  }
`;

const ACCEPT_CUSTOMER_INVITATION = gql`
  mutation AcceptInvitation($token: String!) {
    acceptInvitation(token: $token) {
      id
      userRoles {
        id
        account {
          id
        }
        workspace {
          id
          name
          mode
          workspaceUrl
          zipCode
          street
          city
          state
          countryId
        }
        role {
          name
        }
        customer {
          id
        }
      }
    }
  }
`;

const ACCEPT_TREINCO_APP_INVITATION = gql`
  mutation AcceptTreincoAppInvitation($token: String!) {
    acceptTreincoAppInvitation(token: $token) {
      id
      firstName
      lastName
      email
      isNewUser
    }
  }
`;

const DELETE_INVITATION = gql`
  mutation DeleteInvitation($invitationId: ID!) {
    deleteInvitation(invitationId: $invitationId) {
      affectedRows
    }
  }
`;

const REJECT_INVITATION = gql`
  mutation RejectInvitation($token: String!) {
    rejectInvitation(token: $token) {
      affectedRows
      updated
      errors
    }
  }
`;

export default {
  INVITE_USER_TO_WORKSPACE,
  INVITE_USER_TO_CUSTOMER,
  INVITE_TREINCO_APP_TO_WORKSPACE,
  ACCEPT_WORKSPACE_INVITATION,
  ACCEPT_CUSTOMER_INVITATION,
  ACCEPT_TREINCO_APP_INVITATION,
  DELETE_INVITATION,
  REJECT_INVITATION,
};
